import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {RecommendedList} from "../../../../application/components/multi_lead/multi_lead_simple_recommendations/parts/RecommendedList";
import {LeadModalStep} from "../../../../application/types/LeadModalStep";
import {MultiLeadRecommendationType} from "../../../../application/types/MultiLeadRecommendationType";
import {InquiryButtonTypeName} from "../../../../offer/detail/constants/inquiry_button_type";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../../property/types/IRecommendedProperty";
import {useGetRecommendedPropertiesQuery} from "../../../../recommendations/api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../../../../recommendations/hooks/use_recommended_properties_payload";
import {Country} from "../../../../region/types/Country";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {
    gtmEventShowSimilarPropertiesPremultileadModal,
    gtmEventSubmitSimilarPropertiesPremultileadModal
} from "../../../../tracking/google_tag_manager/gtm_event_similar_properties_premultilead_modal";
import {ViewType} from "../../../../view_type/ViewType";
import {hitMultileadRecommendationShown} from "../../../tracking/hit_multilead_recommendation_shown";
import {MultileadVersion} from "../../../types/MultileadVersion";
import {RecommendationSource} from "../../../types/RecommendationSource";
import {setAllPropertiesCount, setMultileadStep, setPriceRangeMultilead, setSelectedMultileadProperties} from "../../state/multilead_slice";
import {getPriceRangeRecommendationProperties} from "../../utils/get_price_range_recommendation_properties";

interface IProps {
    property: IPropertyDetail;
}

export const MultileadModalRecommendedPropertiesStep = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();
    const [currentSelectedIds, setCurrentSelectedIds] = useState<number[]>([]);
    const dispatch = useAppDispatch();
    const filtersPrice = useAppSelector((state) => state.user.preferences.data?.filters?.price_1);
    const maxPrice = filtersPrice || property.price?.toString();

    const propertyPrice = (property.price !== null && priceFormat(property.price)) || "";

    const {data: recommendedProperties} = useGetRecommendedPropertiesQuery(useRecommendedPropertiesPayload({property, filters: {maxPrice}}));
    const allProperties = recommendedProperties?.results?.concat(property as unknown as IRecommendedProperty);
    const allPropertyIds = allProperties?.map((prop) => prop.id);
    const selectedProperties = allProperties?.filter((elem) => currentSelectedIds.includes(elem.id));
    const priceRange = recommendedProperties && getPriceRangeRecommendationProperties(currentSelectedIds, recommendedProperties.results, property);

    useEffect(() => {
        if (allPropertyIds) {
            setCurrentSelectedIds(allPropertyIds);
        }
        dispatch(setAllPropertiesCount({count: allProperties?.length ?? 0}));
        gtmEventShowSimilarPropertiesPremultileadModal(InquiryButtonTypeName.MOVE_TO_NEXT_STEP, allProperties?.length ?? 0);
        for (const recommendation of recommendedProperties?.results ?? []) {
            hitMultileadRecommendationShown({
                recommendationType: MultiLeadRecommendationType.PROPERTY,
                recommendationId: recommendation.id,
                viewType: ViewType.PROPERTY,
                recommendationSource: RecommendationSource.DISTANCE,
                multileadVersion: MultileadVersion.RP_PREMULTILEAD
            });
        }
    }, []);

    const handlers = {
        checkProperty: (viewType: ViewType, propertyItemId: number) => {
            if (currentSelectedIds) {
                const isSelected = currentSelectedIds?.includes(propertyItemId);
                const updatedProperties = isSelected ? currentSelectedIds?.filter((id) => id !== propertyItemId) : [...currentSelectedIds, propertyItemId];
                setCurrentSelectedIds(updatedProperties);
            }
        },
        goToNextStep: () => {
            priceRange && dispatch(setPriceRangeMultilead({minPrice: priceRange.minPrice, maxPrice: priceRange?.maxPrice}));
            dispatch(setSelectedMultileadProperties({selectedProperties: selectedProperties ?? []}));
            dispatch(setMultileadStep({step: LeadModalStep.APPLICATION_FORM}));
            gtmEventSubmitSimilarPropertiesPremultileadModal(
                InquiryButtonTypeName.MOVE_TO_NEXT_STEP,
                selectedProperties?.length ?? 0,
                allProperties?.length ?? 0
            );
        }
    };

    return (
        <>
            <div className={headerStyle}>
                <HotIcon size="5" wrapperSize="5" wrapperColor="var(--colors-primary)" />
                <Text variant="headline_5">
                    Porównaj i zapytaj o{isMobile && <br />} podobne oferty w najbliższej okolicy z{!isMobile && <br />} niższą ceną.
                </Text>
            </div>
            <RecommendedList
                mainProperty={property}
                recommendationType={MultiLeadRecommendationType.PROPERTY}
                recommended={{properties: recommendedProperties?.results ?? [], offers: []}}
                viewType={ViewType.PROPERTY}
                originalApplicationGeoPoint={property.offer.geo_point}
                selected={currentSelectedIds ?? []}
                handleChange={handlers.checkProperty}
                handlePinClick={() => null}
                originalApplicationEstimatedPrice={propertyPrice}
                originalApplicationCountry={Country.POLAND}
            />
            <Button
                variant="filled_primary"
                className={submitButton}
                size="x-small"
                onClick={handlers.goToNextStep}
                disabled={currentSelectedIds.length === 0 || !currentSelectedIds}
            >
                PRZEJDŹ DALEJ
            </Button>
        </>
    );
};

const headerStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 3,
    p: 2,
    maxWidth: "40rem",

    sm: {
        maxWidth: "max-content"
    },
    md: {
        p: 0
    }
});

const submitButton = css({
    m: 1,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    width: "95%",
    alignSelf: "center",

    sm: {
        width: "100%"
    },

    md: {
        position: "static",
        m: 0,
        minWidth: "20rem"
    }
});
import React, {useEffect, useState} from "react";
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {HotIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {useUserDevice} from "@pg-mono/user-device";

import {RecommendedList} from "../../../../application/components/multi_lead/multi_lead_simple_recommendations/parts/RecommendedList";
import {LeadModalStep} from "../../../../application/types/LeadModalStep";
import {MultiLeadRecommendationType} from "../../../../application/types/MultiLeadRecommendationType";
import {InquiryButtonTypeName} from "../../../../offer/detail/constants/inquiry_button_type";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {IRecommendedProperty} from "../../../../property/types/IRecommendedProperty";
import {useGetRecommendedPropertiesQuery} from "../../../../recommendations/api/get_recommended_properties";
import {useRecommendedPropertiesPayload} from "../../../../recommendations/hooks/use_recommended_properties_payload";
import {Country} from "../../../../region/types/Country";
import {useAppDispatch, useAppSelector} from "../../../../store/hooks";
import {
    gtmEventShowSimilarPropertiesPremultileadModal,
    gtmEventSubmitSimilarPropertiesPremultileadModal
} from "../../../../tracking/google_tag_manager/gtm_event_similar_properties_premultilead_modal";
import {ViewType} from "../../../../view_type/ViewType";
import {hitMultileadRecommendationShown} from "../../../tracking/hit_multilead_recommendation_shown";
import {MultileadVersion} from "../../../types/MultileadVersion";
import {RecommendationSource} from "../../../types/RecommendationSource";
import {setAllPropertiesCount, setMultileadStep, setPriceRangeMultilead, setSelectedMultileadProperties} from "../../state/multilead_slice";
import {getPriceRangeRecommendationProperties} from "../../utils/get_price_range_recommendation_properties";

interface IProps {
    property: IPropertyDetail;
}

export const MultileadModalRecommendedPropertiesStep = (props: IProps) => {
    const {property} = props;
    const {isMobile} = useUserDevice();
    const [currentSelectedIds, setCurrentSelectedIds] = useState<number[]>([]);
    const dispatch = useAppDispatch();
    const filtersPrice = useAppSelector((state) => state.user.preferences.data?.filters?.price_1);
    const maxPrice = filtersPrice || property.price?.toString();

    const propertyPrice = (property.price !== null && priceFormat(property.price)) || "";

    const {data: recommendedProperties} = useGetRecommendedPropertiesQuery(useRecommendedPropertiesPayload({property, filters: {maxPrice}}));
    const allProperties = recommendedProperties?.results?.concat(property as unknown as IRecommendedProperty);
    const allPropertyIds = allProperties?.map((prop) => prop.id);
    const selectedProperties = allProperties?.filter((elem) => currentSelectedIds.includes(elem.id));
    const priceRange = recommendedProperties && getPriceRangeRecommendationProperties(currentSelectedIds, recommendedProperties.results, property);

    useEffect(() => {
        if (allPropertyIds) {
            setCurrentSelectedIds(allPropertyIds);
        }
        dispatch(setAllPropertiesCount({count: allProperties?.length ?? 0}));
        gtmEventShowSimilarPropertiesPremultileadModal(InquiryButtonTypeName.MOVE_TO_NEXT_STEP, allProperties?.length ?? 0);
        for (const recommendation of recommendedProperties?.results ?? []) {
            hitMultileadRecommendationShown({
                recommendationType: MultiLeadRecommendationType.PROPERTY,
                recommendationId: recommendation.id,
                viewType: ViewType.PROPERTY,
                recommendationSource: RecommendationSource.DISTANCE,
                multileadVersion: MultileadVersion.RP_PREMULTILEAD
            });
        }
    }, []);

    const handlers = {
        checkProperty: (viewType: ViewType, propertyItemId: number) => {
            if (currentSelectedIds) {
                const isSelected = currentSelectedIds?.includes(propertyItemId);
                const updatedProperties = isSelected ? currentSelectedIds?.filter((id) => id !== propertyItemId) : [...currentSelectedIds, propertyItemId];
                setCurrentSelectedIds(updatedProperties);
            }
        },
        goToNextStep: () => {
            priceRange && dispatch(setPriceRangeMultilead({minPrice: priceRange.minPrice, maxPrice: priceRange?.maxPrice}));
            dispatch(setSelectedMultileadProperties({selectedProperties: selectedProperties ?? []}));
            dispatch(setMultileadStep({step: LeadModalStep.APPLICATION_FORM}));
            gtmEventSubmitSimilarPropertiesPremultileadModal(
                InquiryButtonTypeName.MOVE_TO_NEXT_STEP,
                selectedProperties?.length ?? 0,
                allProperties?.length ?? 0
            );
        }
    };

    return (
        <>
            <div className={headerStyle}>
                <HotIcon size="5" wrapperSize="5" wrapperColor="var(--colors-primary)" />
                <Text variant="headline_5">
                    Porównaj i zapytaj o{isMobile && <br />} podobne oferty w najbliższej okolicy z{!isMobile && <br />} niższą ceną.
                </Text>
            </div>
            <RecommendedList
                mainProperty={property}
                recommendationType={MultiLeadRecommendationType.PROPERTY}
                recommended={{properties: recommendedProperties?.results ?? [], offers: []}}
                viewType={ViewType.PROPERTY}
                originalApplicationGeoPoint={property.offer.geo_point}
                selected={currentSelectedIds ?? []}
                handleChange={handlers.checkProperty}
                handlePinClick={() => null}
                originalApplicationEstimatedPrice={propertyPrice}
                originalApplicationCountry={Country.POLAND}
            />
            <Button
                variant="filled_primary"
                className={submitButton}
                size="x-small"
                onClick={handlers.goToNextStep}
                disabled={currentSelectedIds.length === 0 || !currentSelectedIds}
            >
                PRZEJDŹ DALEJ
            </Button>
        </>
    );
};

const headerStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    mb: 3,
    p: 2,
    maxWidth: "40rem",

    sm: {
        maxWidth: "max-content"
    },
    md: {
        p: 0
    }
});

const submitButton = css({
    m: 1,
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10,
    width: "95%",
    alignSelf: "center",

    sm: {
        width: "100%"
    },

    md: {
        position: "static",
        m: 0,
        minWidth: "20rem"
    }
});
